"use client";

import { Button } from "@mantine/core";

import { STAGE_VIEW } from "../constants";
import { useStage } from "../StageProvider";
import classes from "./DecisionsView.module.css";

/**
 * The open decision's ask, which opens its room: it brings the room's step to
 * the reader. Pinned, that switches the stage, and the room opens out of this
 * row.
 */
export default function MakeTheCallButton() {
  const { scrollToStep } = useStage();

  return (
    <Button
      variant="gradient"
      gradient={{ from: "blue", to: "cyan", deg: 90 }}
      className={classes.askButton}
      onClick={() => scrollToStep(STAGE_VIEW.ROOM)}
    >
      Make the call
    </Button>
  );
}
